var _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMBgLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 99.65 177.16"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "m_bg_line_svg__clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "m_bg_line_svg__cls-1",
    d: "M-.35-.61h100v177.78h-100z"
  })), /*#__PURE__*/React.createElement("style", null, "@keyframes opacity-ani{0%,to{opacity:.4}75%{opacity:1}}.m_bg_line_svg__path{fill:none;stroke:#8faeff;stroke-width:.2px;stroke-dasharray:.8px;opacity:.4;animation-name:opacity-ani;animation-duration:3s;animation-direction:alternate;animation-iteration-count:infinite;animation-timing-function:cubic-bezier(.55,.45,.45,.5)}"))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m_bg_line_svg__clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "m_bg_line_svg__path",
    style: {
      animationDelay: "0s"
    },
    d: "M0 56.79l79.46-45.68L60.14 0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m_bg_line_svg__path",
    style: {
      animationDelay: "1s"
    },
    d: "M99.17 20.16l-40.7 23.23 41.12 23.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m_bg_line_svg__path",
    style: {
      animationDelay: "2s"
    },
    d: "M0 121.81l59.09-34.25L99.58 111"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m_bg_line_svg__path",
    style: {
      animationDelay: "3s"
    },
    d: "M79.46 177.16L8.69 136.48l24.78-14.17L0 102.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m_bg_line_svg__path",
    style: {
      animationDelay: "4s"
    },
    d: "M17.85 177.16l81.73-47"
  })));
}

export default SvgMBgLine;